import { useUiStrings } from '@/hooks/useUiStrings'
import { useVersionCheck } from '@/hooks/useVersionCheck'

/**
 * Non-blocking toast that surfaces when the deployed SPA build differs from
 * the one the user is currently running. Rendered inside the authenticated
 * shell so it appears on every protected route without covering the primary
 * meeting controls.
 *
 * Clicking either the banner body or the Reload button reloads the page,
 * which pulls the fresh HTML + hashed bundle from the server / CDN.
 */
export default function AppReloadBanner() {
  const { t } = useUiStrings()
  const { updateAvailable, reload } = useVersionCheck()

  if (!updateAvailable) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed left-1/2 top-4 z-[60] flex -translate-x-1/2 items-center gap-3 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm font-semibold text-blue-800 shadow-lg dark:border-blue-500/40 dark:bg-blue-500/10 dark:text-blue-200"
    >
      <button
        type="button"
        onClick={reload}
        className="text-left underline decoration-blue-400 underline-offset-2 hover:decoration-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
      >
        {t.newVersionAvailable}
      </button>
      <button
        type="button"
        onClick={reload}
        className="rounded-md bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
      >
        {t.reloadNow}
      </button>
    </div>
  )
}
